module.exports = __webpack_public_path__ + "media/images/static/top/urban/right_mobile-7450bff0d03063677dc45c60539e9e50.png";